function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral-es6';
import classNames from 'classnames';

var Currency = /*#__PURE__*/function (_React$Component) {
  _inherits(Currency, _React$Component);

  function Currency() {
    _classCallCheck(this, Currency);

    return _possibleConstructorReturn(this, _getPrototypeOf(Currency).apply(this, arguments));
  }

  _createClass(Currency, [{
    key: "formatter",
    value: function formatter(value) {
      var precision = this.props.precision;
      var formatedValue = value;

      if (value !== '') {
        var format = '0,0.00'; // default format

        if (typeof precision !== 'undefined') {
          format = '0,0.'.padEnd(4 + precision, '0');
        }

        formatedValue = numeral(value).format(format);
      }

      return formatedValue;
    }
  }, {
    key: "getSymbol",
    value: function getSymbol(symbol) {
      return symbol === 'CNY' ? '￥' : symbol;
    }
  }, {
    key: "renderReference",
    value: function renderReference() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          value = _this$props.value,
          reference = _this$props.reference,
          symbol = _this$props.symbol;

      if (typeof value !== 'undefined' && typeof reference !== 'undefined' && value !== reference) {
        return React.createElement("span", {
          className: "".concat(prefixCls, "-reference")
        }, React.createElement("span", {
          className: "".concat(prefixCls, "-reference-prefix")
        }, this.getSymbol(symbol)), React.createElement("span", {
          className: "".concat(prefixCls, "-reference-money")
        }, this.formatter(reference)));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _rootCls;

      var _this$props2 = this.props,
          symbol = _this$props2.symbol,
          value = _this$props2.value,
          prefixCls = _this$props2.prefixCls,
          size = _this$props2.size,
          vertical = _this$props2.vertical,
          color = _this$props2.color;
      var showSymbol = this.getSymbol(symbol);
      var isSymbol = Currency.allSymbol.includes(showSymbol);
      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_rootCls, "".concat(prefixCls, "-vertical"), vertical), _defineProperty(_rootCls, "".concat(prefixCls, "-text"), !isSymbol), _defineProperty(_rootCls, "".concat(prefixCls, "-symbol"), isSymbol), _defineProperty(_rootCls, "".concat(prefixCls, "-fat"), showSymbol === '￥'), _defineProperty(_rootCls, color, 1), _rootCls);
      return React.createElement("span", {
        className: classNames(rootCls)
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-main")
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-main-prefix")
      }, this.getSymbol(symbol)), React.createElement("span", {
        className: "".concat(prefixCls, "-main-money")
      }, this.formatter(value))), this.renderReference());
    }
  }]);

  return Currency;
}(React.Component);

_defineProperty(Currency, "propTypes", {
  precision: PropTypes.number,
  value: PropTypes.number,
  symbol: PropTypes.string,
  prefixCls: PropTypes.string,
  reference: PropTypes.number,
  // 参照
  vertical: PropTypes.bool,
  color: PropTypes.string
});

_defineProperty(Currency, "defaultProps", {
  precision: 2,
  symbol: '',
  prefixCls: 'mkui-currency',
  vertical: false
});

_defineProperty(Currency, "allSymbol", ['￥', '$', '€', '￡']);

export { Currency as default };
//# sourceMappingURL=index.js.map
